import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { GetConsentByIdResponse } from '../../../../../Models/Response/Consent/GetConsentById';
import { getConsentByConsentId } from '../../../../../Services/ConsentServices/ConsentService';
import { ConsentStatusType } from '../../../../../Utils/Constants/consentTypes';
import CommonConsentDetails from '../../CommonConsentDetails';
import '../index.css';

interface IPausedConsentProps {
  consentUniqueId: string;
  type: string;
  onConsentStatusUpdate: (type: string) => void;
  createdOrUpdatedOn: string;
}

const PausedConsent: React.FC<IPausedConsentProps> = ({
  consentUniqueId,
  type,
  onConsentStatusUpdate,
  createdOrUpdatedOn,
}) => {
  const [consentDetailsById, setConsentDetailsById] = useState({
    Customer: { id: '' },
    DataConsumer: { dataConsumerType: '', id: '' },
    DataFilter: [{ type: '', operator: '', value: '' }],
    DataLife: { unit: '', value: 0 },
    FIDataRange: { from: '', to: '' },
    Frequency: { unit: '', value: 0 },
    Purpose: { category: { type: '' }, code: '', refUri: '', text: '' },
    consentExpiry: '',
    consentMode: '',
    consentStart: '',
    consentTypes: [''],
    fetchType: '',
    fiTypes: [''],
    DataProvider: { id: '', type: '' },
    Accounts: [
      {
        fiType: '',
        fipId: '',
        fipName: '',
        accType: '',
        linkRefNumber: '',
        maskedAccNumber: '',
      },
    ],
  });

  useEffect(() => {
    getConsentByConsentId(consentUniqueId)
      .then((res) => res.data)
      .then((res: GetConsentByIdResponse) => {
        setConsentDetailsById(res);
      });
  }, [consentUniqueId]);
  const { t } = useTranslation();

  return (
    <>
      <CommonConsentDetails
        createdOrUpdatedOn={createdOrUpdatedOn}
        type={type}
        consentByUniqueIdDetails={consentDetailsById}
        account={consentDetailsById.Accounts}
      />

      <div className='activeButtonGroup'>
        <Button
          //   loading={isLinkAccountLoading}
          id='linkAccount'
          className='primaryButton'
          // tslint:disable-next-line: jsx-no-lambda
          onClick={() => onConsentStatusUpdate(ConsentStatusType.ACTIVE)}
        >
          {t('REACTIVATE CONSENT')}
        </Button>
        <Button
          className='primaryButton'
          id='linkAccount'
          // tslint:disable-next-line: jsx-no-lambda
          onClick={() => onConsentStatusUpdate(ConsentStatusType.REVOKED)}
        >
          {t('REVOKE CONSENT')}
        </Button>
      </div>
    </>
  );
};

export default PausedConsent;
